import { createTheme } from '@mui/material';
import { baseTheme } from './baseTheme';

export default createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#D9FF75',
      light: '#E5FF99',
      dark: '#A3CD32',
      contrastText: '#121212',
    },
    secondary: {
      main: '#408DFF',
      light: '#6BA9FF',
      dark: '#135BC4',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#EF5350',
      light: '#1A1A1A',
      dark: '#C62828',
      contrastText: '#FFFFFF',
    },
    neutral: {
      main: '#B0B0B0',
      contrastText: '#424242',
    },
    background: {
      default: '#121212',
      paper: '#1E1E1E',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B0B0B0',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      'San Francisco',
      'Helvetica Neue',
      'Helvetica',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 600,
      letterSpacing: '-0.015em',
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 500,
      letterSpacing: '-0.01em',
      lineHeight: 1.3,
    },
    h4: {
      fontWeight: 500,
      letterSpacing: '-0.008em',
      lineHeight: 1.4,
    },
    h5: {
      fontWeight: 500,
      letterSpacing: '-0.005em',
      lineHeight: 1.4,
    },
    h6: {
      fontWeight: 500,
      letterSpacing: '-0.003em',
      lineHeight: 1.5,
    },
    body1: {
      lineHeight: 1.5,
      letterSpacing: '-0.003em',
    },
    body2: {
      lineHeight: 1.5,
      letterSpacing: '-0.002em',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
      letterSpacing: '-0.003em',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 2,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        },
      },
    },
  },
  shape: {
    borderRadius: 2,
  },
  custom: {
    titleSpacing: {
      marginBottom: 3, // 16px (2 * 8px)
    }
  }
}); 